import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

//const root = ReactDOM.createRoot(document.getElementById('root'));
// Create a ShadowRoot on the existing #root host element
const host = document.getElementById('root');
const shadowRoot = host.attachShadow({ mode: 'open' });

// Inject the compiled Tailwind CSS (copied to /public/shadow.css)
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute(
  'href',
  'https://fotkunato.cz/wp-content/plugins/build/static/css/shadow.css'
);
shadowRoot.appendChild(link);

// Create a mount node inside the shadow
const mount = document.createElement('div');
shadowRoot.appendChild(mount);

// Mount React into the shadow root
const root = ReactDOM.createRoot(mount);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
